<template>
  <header
    class="header-height fixed left-0 top-0 z-header w-full bg-white py-3 tablet:py-[15px]"
    :class="headerClass"
  >
    <div class="container-wrap">
      <div
        class="flex w-full items-center justify-between desktop:justify-start"
      >
        <LayoutHeaderLogo />

        <LayoutSearchDesktop
          v-if="isDesktop && isSearchMenuOpen"
          class="mr-4"
        />

        <LayoutHeaderMenu
          v-show="isDesktop && !isSearchMenuOpen"
          class="mr-4"
        />

        <!-- ** Desktop ** -->
        <div v-if="isDesktop" class="flex items-center">
          <!-- Search Button -->
          <LayoutHeaderSearchButton class="mr-4" />
          <!-- Locale Button -->
          <LayoutHeaderLocale class="mr-4" />
          <!-- Contact Us Button -->
          <LayoutHeaderContactUsButton class="mr-4" />
          <!-- Console Button -->
          <LayoutHeaderConsoleButton class="mr-4" />
          <!-- Login Button -->
          <LayoutHeaderLoginButton />
          <!-- Account Button -->
          <LayoutHeaderAccount />
        </div>

        <!-- ** Tablet ** -->
        <div v-if="isTablet" class="flex items-center">
          <!-- Search Button -->
          <LayoutHeaderSearchButton v-show="!isMenuOpen" class="mr-3" />
          <!-- Locale Button -->
          <LayoutHeaderLocale v-show="isMenuOpen" class="mr-3" />
          <!-- Contact Us Button -->
          <LayoutHeaderContactUsButton v-show="isMenuOpen" class="mr-3" />
          <!-- Console Button -->
          <LayoutHeaderConsoleButton v-show="!isMenuOpen" class="mr-3" />
          <!-- Login Button -->
          <LayoutHeaderLoginButton v-show="!isMenuOpen" class="mr-3" />
          <!-- Account Button -->
          <LayoutHeaderAccount v-show="!isMenuOpen" class="mr-3" />
          <!-- Menu Button -->
          <LayoutHeaderMenuButton />
        </div>

        <!-- ** Mobile ** -->
        <div v-if="isMobile" class="flex items-center">
          <!-- Search Button -->
          <LayoutHeaderSearchButton v-show="!isMenuOpen" class="mr-1" />
          <!-- Console Button -->
          <LayoutHeaderConsoleButton
            v-show="!isMenuOpen"
            :class="isLogin ? 'mr-2' : 'mr-1'"
          />
          <!-- Login Button -->
          <LayoutHeaderLoginButton
            v-show="!isMenuOpen"
            :class="isLogin ? 'mr-2' : 'mr-1'"
          />
          <!-- Account Button -->
          <LayoutHeaderAccount
            v-show="!isMenuOpen"
            :class="isLogin ? 'mr-2' : 'mr-1'"
          />
          <!-- Menu Button -->
          <LayoutHeaderMenuButton />
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
  const menuStore = useMenuStore();
  const profileStore = useProfileStore();
  const searchMenuStore = useSearchMenuStore();
  const { isMenuOpen } = storeToRefs(menuStore);
  const { isLogin } = storeToRefs(profileStore);
  const { isMenuOpen: isSearchMenuOpen } = storeToRefs(searchMenuStore);
  const { isDesktop, isTablet, isMobile } = useScreen();

  const headerClass = computed((): string => {
    if (!isMenuOpen.value) {
      return 'shadow-header';
    }
    if (!isMobile.value) {
      return 'border-b border-solid border-gray-400';
    }
    return '';
  });
</script>

<style lang="scss" scoped>
  .header-height {
    @apply h-header-mobile-height tablet:h-header-height;
  }
</style>
